import { useState } from 'react';
import { Printer } from 'lucide-react';
import { useMoldQRCode } from '../../hooks/useMoldQRCode';
import QRCodeErrorModal from '../shared/QRCodeErrorModal';

interface PrintQRCodeButtonProps {
    moldId?: number;
}

const PrintQRCodeButton = ({ moldId }: PrintQRCodeButtonProps) => {
    const { downloadMoldQRCode, isLoading, error, clearError } = useMoldQRCode();
    const [showErrorModal, setShowErrorModal] = useState(false);

    const handleDownload = async () => {
        try {
            if (!moldId) {
                throw new Error('รหัสแม่พิมพ์ไม่ถูกต้อง');
            }
            await downloadMoldQRCode(moldId);
        } catch (err: any) {
            setShowErrorModal(true);
        }
    };

    return (
        <>
            <button
                data-cy="print-qr"
                onClick={handleDownload}
                disabled={isLoading}
                className={`shadow-xl text-base w-full py-3 px-4 rounded-md flex items-center justify-center bg-indigo-500 hover:bg-indigo-600 text-white focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 ${isLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
            >
                <Printer className="h-5 w-5 mr-2" />
                <span>{isLoading ? 'กำลังดาวน์โหลด...' : 'พิมพ์ QR Code แม่พิมพ์'}</span>
            </button>
            <QRCodeErrorModal
                isOpen={showErrorModal}
                error={error}
                onClose={() => {
                    setShowErrorModal(false);
                    clearError();
                }}
            />
        </>
    );
};

export default PrintQRCodeButton;